var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.accordionVisible,
          expression: "accordionVisible",
        },
      ],
    },
    [
      _c(
        "div",
        { class: _vm.headerClass, attrs: { id: "heading-" + _vm.identifier } },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-block btn-lg p-0 border-0",
              class: [
                _vm.loopIndex === 0 && _vm.firstElementShown ? "" : "collapsed",
                _vm.showCollapseIcons && !_vm.isPreview
                  ? "position-relative"
                  : "",
              ],
              attrs: {
                "data-toggle": "collapse",
                "data-target": "#content-" + _vm.identifier,
                "aria-expanded": [_vm.loopIndex === 0 && _vm.firstElementShown],
                "aria-controls": "content-" + _vm.identifier,
              },
            },
            [
              _vm._t("header"),
              _vm._v(" "),
              _vm.showCollapseIcons && !_vm.isPreview
                ? _c(
                    "div",
                    {
                      staticClass: "position-absolute d-flex",
                      class: _vm.alignmentIconClass,
                      staticStyle: {
                        top: "0",
                        right: "0",
                        bottom: "0",
                        left: "0",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa m-3",
                        class: [
                          _vm.loopIndex === 0 && _vm.firstElementShown
                            ? _vm.iconActiveClass
                            : _vm.iconClosedClass,
                          _vm.customIconClass,
                        ],
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "myBody",
          staticClass: "collapse",
          class: [_vm.loopIndex === 0 && _vm.firstElementShown ? "show" : ""],
          attrs: {
            id: "content-" + _vm.identifier,
            "aria-labelledby": "heading-" + _vm.identifier,
            "data-parent": [
              _vm.behavior === "showOneCollapseRest"
                ? "#" + _vm.accordionId
                : "",
            ],
          },
        },
        [_vm._t("body")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }